import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainMenuComponent } from './main-menu.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { ChangeCompactModeComponent } from './change-compach-mode/change-compact-mode.component';

@NgModule({
    imports: [CommonModule, UtilitiesModule, MatMenuModule, MatIconModule, MatButtonModule],
    declarations: [MainMenuComponent, MenuItemComponent, ChangeCompactModeComponent],
    exports: [MainMenuComponent],
})
export class MainMenuModule {}
